module.exports = "<span class=\"badge-product badge--circle badge--saving\" ng-class=\"::ctrl.classes\">\r\n    <span class=\"badge_title\">\r\n        was\r\n        <span class=\"badge_subtitle\">\r\n            <sup>$</sup>{{ctrl.wasPrice | bwsDollars}}<sup ng-if=\"(ctrl.wasPrice | bwsCents) !== '00'\">{{ctrl.wasPrice | bwsCents}}</sup>\r\n        </span>\r\n \r\n    </span>\r\n</span>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/badges/super-savers-badge-template.html
 ** module id = 891
 ** module chunks = 1
 **/